import { ProductRaw } from '../utils/model';

export const productAll = 'Search All';
export const multilabProductsRaw: ProductRaw[] = [
  {
    name: 'Mappa',
    projectPaths: [],
    groupPaths: ['multilab/products/mappa'],
  },
  {
    name: 'Anotonov.Media',
    pmProjectPath: 'multilab/products/antonov.media/am-pm',
    projectPaths: [],
    groupPaths: ['multilab/products/antonov.media'],
  },

  {
    name: 'BPS',
    projectPaths: [
      'multilab/crypto_payments/bps/bps_frontend',
      'multilab/crypto_payments/bps/bps_backend',
      'multilab/crypto_payments/bps/bps-pm',
      'multilab/crypto_payments/bps/bps-modern-deploy',
      'multilab/crypto_payments/bps/bps_deploy',
      'multilab/crypto_payments/bps/bps-invoice-frontend',
    ],
    pmProjectPath: 'multilab/crypto_payments/bps/bps-pm',
    groupPaths: ['multilab/crypto_payments/bps/ebps'],
  },
  {
    name: 'BPS MPC',
    projectPaths: [],
    pmProjectPath: 'multilab/crypto_payments/bps/bps-mpc/bps-mpc-pm',
    groupPaths: ['multilab/crypto_payments/bps/bps-mpc'],
  },
  {
    name: 'Subledger',
    projectPaths: [],
    pmProjectPath: 'multilab/crypto_payments/subledger/subledger-pm',
    groupPaths: ['multilab/crypto_payments/subledger'],
  },
  {
    name: 'ChestGame',
    projectPaths: [],
    groupPaths: ['multilab/products/cendterra/chests'],
  },
  {
    name: 'Lottery',
    projectPaths: [],
    groupPaths: ['multilab/products/cendterra/lottery'],
  },
  {
    name: 'Builder',
    pmProjectPath: 'multilab/products/builder/builder-pm',
    projectPaths: [],
    groupPaths: ['multilab/products/builder'],
  },
  {
    name: 'Cendterra',
    projectPaths: ['multilab/products/cendterra/cendterra-pm'],
    groupPaths: ['multilab/products/cendterra/cendterra'],
  },
  {
    name: 'TeleFood',
    pmProjectPath: 'multilab/products/TeleMenu/telemenu-pm',
    projectPaths: [],
    groupPaths: ['multilab/products/TeleMenu'],
  },
  {
    name: 'TronSave',
    projectPaths: [],
    groupPaths: ['multilab/crypto_payments/tronsave'],
  },
  {
    name: 'Yoga',
    pmProjectPath: 'multilab/products/yoga-platform/yoga-pm',
    projectPaths: [],
    groupPaths: ['multilab/products/yoga-platform'],
  },
  {
    name: 'Telejobs',
    projectPaths: [],
    pmProjectPath: 'https://gitlab.maugry.ru/telejobs/project',
    groupPaths: ['telejobs'],
  },
  {
    name: 'ProfitLife',
    projectPaths: [],
    pmProjectPath: 'multilab/projects/profit-life-group/profit-life-pm',
    groupPaths: ['multilab/projects/profit-life-group'],
  },
  {
    name: 'General',
    projectPaths: ['multilab/maugry-general'],
    groupPaths: [],
  },
  {
    name: productAll,
    projectPaths: [],
    groupPaths: ['multilab'],
  },
];
